import React from "react";

// import { UserManager } from "oidc-client";
// import OpenIDConnectClientConfig from "../../helpers/open-id-configuration";

import { Avatar, Typography, Button } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import Separator from "../Separator";

const Account = ({ user, isLoading }) => {
    const handleLogout = () => {
        localStorage.removeItem("access_token");
        window.location = `/login`;
    };

    return (
        <div
            style={{
                padding: "18px",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "space-between",
                width: "240px",
                height: "240px"
            }}
        >
            {isLoading ? (
                <div style={{ marginTop: "30px" }}>
                    <Skeleton
                        variant="circle"
                        width="80px"
                        height="80px"
                    />
                    <Skeleton animation="wave" />
                    <Skeleton animation="wave" />
                </div>
            ) : (
                <>
                    <Avatar
                        className="rounded-circle header-avatar"
                        src={user?.photo ?? null}
                        alt="profile"
                        style={{
                            width: "80px",
                            height: "80px"
                        }}
                    />

                    <Separator variant="vertical" size={8} />

                    <Typography
                        variant="h6"
                        style={{ fontWeight: "bold" }}
                    >
                        {user?.fullName || "User"}
                    </Typography>

                    <Typography style={{ color: "rgba(23, 36, 54, 0.6)" }}>
                        {user?.email || "user@domain.com"}
                    </Typography>

                    <Separator variant="vertical" />

                    <Button
                        color="secondary"
                        onClick={handleLogout}
                    >
                        Logout
                    </Button>
                </>
            )}
        </div>
    );
};

export default Account;